// ItemsWrapper.tsx
import React, { ReactNode } from "react";
import s from "../Segments.module.scss";
import cn from "classnames";
import c from "../../../styles/container.module.scss";
import { SegmentsProvider } from "./SegmentsContext";

type Props = {
  children: ReactNode;
  spaceHorizontal?: boolean;
};

const ItemsWrapper = ({ children, spaceHorizontal }: Props) => {
  return (
    <SegmentsProvider>
      <div
        className={cn(c.xWide, s.itemsWrapper, {
          [s.spaceHorizontal]: spaceHorizontal,
        })}
      >
        {children}
      </div>
    </SegmentsProvider>
  );
};

export default ItemsWrapper;
